/* eslint-disable react/no-multi-comp */
/* eslint-disable react/display-name */
import {
  Person as PersonIcon,
  PeopleOutline as SportsmenIcon,
  Streetview as ApplicationsIcon,
  Settings as SettingsIcon,
  SportsMma as CompetitionIcon,
  History as AuditLogIcon,
  GridOn as TatamiIcon,
  CompareArrows as DuplicatesIcon,
} from '@material-ui/icons';
import { appRoutes, userRoles } from "../../../../constants";

export default [
  {
    title: 'menu.competition',
    availableForRoles: [userRoles.USER],
    pages: [
      {
        title: 'menu.competition',
        href: appRoutes.COMPETITIONS_PAGE,
        icon: CompetitionIcon,
        availableForRoles: [userRoles.USER],
      },
      {
        // A secretary's way to their own mat — without it a ROLE_SECRETARY
        // user had only an «Attendance» icon to find it by (26 Sep 2026).
        title: 'menu.myTatamis',
        href: appRoutes.MY_TATAMIS_PAGE,
        icon: TatamiIcon,
        availableForRoles: [userRoles.SECRETARY, userRoles.MAIN_SECRETARY],
      },
      {
        title: 'menu.applications',
        href: appRoutes.APPLICATIONS_PAGE,
        icon: ApplicationsIcon,
        availableForRoles: [userRoles.TRAINER, userRoles.ADMIN, userRoles.SUPER_ADMIN],
      },
      {
        title: 'menu.profiles',
        href: appRoutes.PROFILES_PAGE,
        icon: SportsmenIcon,
        availableForRoles: [userRoles.ADMIN, userRoles.SUPER_ADMIN],
      },
      {
        title: 'menu.sportsmen',
        href: appRoutes.SPORTSMEN_PAGE,
        icon: SportsmenIcon,
        availableForRoles: [userRoles.TRAINER, userRoles.ADMIN, userRoles.SUPER_ADMIN],
      },
      {
        title: 'menu.competitionSettings',
        href: appRoutes.COMPETITION_SETTINGS_PAGE,
        icon: SettingsIcon,
        availableForRoles: [userRoles.ADMIN, userRoles.SUPER_ADMIN],
        children: [
          {
            title: 'page.competitionSetting.competitions.tabTitle',
            href: appRoutes.COMPETITION_SETTINGS_PAGE + '/competitions'
          },
          {
            title: 'page.competitionSetting.clubs.title',
            href: appRoutes.COMPETITION_SETTINGS_PAGE + '/clubs'
          },
          {
            title: 'page.competitionSetting.rules.title',
            href: appRoutes.COMPETITION_SETTINGS_PAGE + '/rules'
          },
          {
            title: 'page.competitionSetting.locations.title',
            href: appRoutes.COMPETITION_SETTINGS_PAGE + '/locations'
          },
          {
            title: 'page.competitionSetting.associations.title',
            href: appRoutes.COMPETITION_SETTINGS_PAGE + '/associations'
          },
          {
            title: 'page.competitionSetting.fees.title',
            href: appRoutes.COMPETITION_SETTINGS_PAGE + '/fees'
          },
          {
            title: 'page.competitionSetting.users.title',
            href: appRoutes.COMPETITION_SETTINGS_PAGE + '/users'
          },
          {
            // Login history: who signed in, from where, and who failed to.
            // SUPER-ADMIN only, enforced by the API — the tab itself is also
            // hidden and the URL refused (CompetitionSettings.js).
            title: 'page.competitionSetting.loginLogs.tabTitle',
            href: appRoutes.COMPETITION_SETTINGS_PAGE + '/login-logs',
            availableForRoles: [userRoles.SUPER_ADMIN],
          },
        ]
      },
      {
        // The whole audit trail. Top level rather than a settings tab: it is
        // about the system, not about a competition.
        title: 'menu.auditLog',
        href: appRoutes.AUDIT_LOG_PAGE,
        icon: AuditLogIcon,
        availableForRoles: [userRoles.SUPER_ADMIN],
      },
      {
        // Profiles that are the same person. Super-admin only: merging two of
        // them rewrites competition history across several years, so it sits
        // at the same trust level as the correction workflow.
        title: 'menu.profileDuplicates',
        href: appRoutes.PROFILE_DUPLICATES_PAGE,
        icon: DuplicatesIcon,
        availableForRoles: [userRoles.SUPER_ADMIN],
      },
    ]
  },
  {
    title: 'menu.user',
    availableForRoles: [userRoles.ADMIN, userRoles.SUPER_ADMIN],
    pages: [
      {
        title: 'account.title',
        href: appRoutes.ACCOUNT_PAGE,
        icon: PersonIcon,
        children: [
          {
            title: 'menu.userGeneral',
            href: appRoutes.ACCOUNT_PAGE + '/general',
          },
          {
            title: 'menu.userSecurity',
            href: appRoutes.ACCOUNT_PAGE + '/security',
          }
        ]
      },
    ]
  },
];
